<template>
    <el-dialog title="帮扶中心实战超市"
               :visible.sync="chaoshiShow"
               width="80%">
        <div class="lottery">
            <span v-for="(item,index) in lottery.db"
                  :key="index"
                  :class="lottery.index == index?'active':''"
                  @click="
				  	lottery.active = item.dictValue;
				  	lottery.index = index;
				  	getList()
				">{{item.dictLabel}}</span>
            <div class="msg">温馨提示:目前开放双色球和大乐透，仅实体投注站可以认购</div>
        </div>
        <div class="sub">
            <div class="team">
                <div v-for="(item,index) in lotteryTeam"
                     :key="index">
                    <span>{{ item.name }} :</span>
                    <div>
                        <span v-for="(ite,idx) in item.list"
                              :key="idx"
                              @click="toggleTeam(ite)"
                              :style="{color:ite.active}">{{ ite.name }}</span>
                    </div>
                </div>
            </div>
            <span class="btn">投注站申请帮扶</span>
        </div>
        <div class="tit">
            <div>
                <h3>{{ lottery.db[lottery.index] && lottery.db[lottery.index].dictLabel }}{{ latestIssue }}期实战团队方案汇总</h3>
                <div>
                    <span @click="toggleNumber('latestIssue',0)"
                          :class="{active:flagMark==0}">最新期</span>
                    <span @click="toggleNumber('prev',1)"
                          :class="{active:flagMark==1}">上一期</span>
                    <span @click="toggleNumber('next',2)"
                          :class="{active:flagMark==2}">下一期</span>
                </div>
            </div>
            <div class="btn">篮球由彩票代表确定</div>
            <!-- <div>双色球开奖结果：每周二、四、日21:30</div> -->
            <div v-if="lottery.active == 0">双色球开奖结果：每周二，四，日 21：30</div>
            <div v-if="lottery.active == 1">大乐透开奖结果：每周一，三，六 21：25</div>
            <div v-if="lottery.active == 2">福彩3D开奖结果：每日 21：15（3d试机号18:30）</div>
            <div v-if="lottery.active == 3">排列三开奖结果：每日 20：45</div>
        </div>
        <el-table v-loading="tableLoading"
                  :data="list"
                  :header-cell-style="{'textAlign':'center'}"
                  :cell-style="{'textAlign':'center'}">
            <el-table-column type="index"
                             label="序号"></el-table-column>
            <el-table-column prop="preNumber"
                             label="期号"></el-table-column>
            <el-table-column prop="teamName"
                             label="缩水团队"></el-table-column>
            <el-table-column prop="teamSlogan"
                             label="团队口号"></el-table-column>
            <el-table-column prop="fenhong"
                             label="上期实战盈亏状态"
                             width="150">
            </el-table-column>
            <el-table-column prop="schemeFileId"
                             label="方案编号"></el-table-column>
            <el-table-column prop="createTime"
                             label="团队方案发布时间"
                             width="150"></el-table-column>
            <el-table-column prop="purchaseLimit"
                             label="限购数量"></el-table-column>
            <el-table-column label="认购状态">
                <template slot-scope="scope">
                    {{scope.row.buyStatus}}
                    <!-- {{scope.row.purchaseLimit - (scope.row.inventory / scope.row.purchaseLimit)}} -->
                </template>
            </el-table-column>
            <el-table-column prop="title"
                             label="实战方案">
                <template slot-scope="scope">
                    <el-button type="text">下载</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="fenye">
            <span class="zhanwei"></span>
            <el-pagination style="padding-top:20px;text-align:right"
                           background
                           layout="prev, pager, next"
                           @current-change="changePage"
                           :page-size="listPagin.limit"
                           :total="listPagin.total">
            </el-pagination>
            <div style="display:flex;align-items:center">自定义期号<el-input placeholder=""
                          style="width:100px"></el-input><span>搜索</span></div>
        </div>

        <el-dialog title="上期实战盈亏状态"
                   :visible.sync="yingkui_show"
                   :append-to-body='true'
                   width="80%">
            <!-- <el-select v-model="team.value"
                       placeholder="请选择团队">
                <el-option v-for="(item, index) in team.arr"
                           :key="index"
                           :label="item.label"
                           :value="item.value"></el-option>
            </el-select> -->

            <div class="selectMenu">
                <div v-for="(item,index) of lotteryTeam"
                     :key="index">
                    <span>{{item.name}}：</span>
                    <div>
                        <span v-for="(ite,idx) of item.list"
                              :key="idx">{{ite}}</span>
                    </div>
                </div>
            </div>

            <el-table>
                <el-table-column label="序号"></el-table-column>
                <el-table-column label="期号"
                                 prop="preNumber"></el-table-column>
                <el-table-column label="缩水团队"></el-table-column>
                <el-table-column label="团队口号"></el-table-column>
                <el-table-column label="实战票盈亏总额"></el-table-column>
                <el-table-column label="方案编号"></el-table-column>
                <el-table-column label="团队方案发布时间"></el-table-column>
                <el-table-column label="限购数量"></el-table-column>
                <el-table-column label="认购状态"></el-table-column>
                <el-table-column label="操作"></el-table-column>
            </el-table>
        </el-dialog>

    </el-dialog>
</template>

<script>
import { schemelist, GetLotteryTeam, GetLotteryList } from "@/api/personalCenter"
import { queryLotteryType } from '@/api/common'
export default {
    data () {
        return {
            chaoshiShow: false,
            lottery: {
                db: [],
                active: '0',
                index: 0
            },

            list: [],

            yingkui_show: false,

            lotteryTeam: [],

            tableLoading: true,
            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },


            latestIssue: '',  //最新期

            isTogglenumber: true,  //是否点击了上一期下一期按钮

            flagMark: 0,  //期号标记   最新期，上一期，下一期
        }
    },
    mounted () {

        new Promise(resolve => {
            // 获取彩种
            queryLotteryType().then(res => {
              console.log('res(queryLotteryType)', res);
                let lotteryDb = res.data.map(item => { return { dictLabel: item.dictLabel, dictValue: item.dictValue } })
                this.lottery.db = lotteryDb.splice(0, 2)
                this.getList()
                resolve()
            })
        }).then(res => {
            return new Promise(resolve => {
                // console.log('2');
            })
        })

        // 获取彩种团队
        GetLotteryTeam().then(res => {
            res.forEach(item => {
                item.list = item.list.map(team => ({ active: false, name: team }));
            });
            this.lotteryTeam = res
        })
    },
    methods: {
        getList (isTeam, teamName = '') {
            let fn = isTeam ? GetLotteryList : schemelist,
                params = {
                    pageNum: this.listPagin.page,
                    pageSize: this.listPagin.limit,
                    preType: this.lottery.active,
                    preNumber: this.latestIssue,	//期数（不传默认最新期）
                    type:'0'
                },
                teamParams = {
                    preType: this.lottery.active,
                    teamName,
                }

            fn(isTeam ? teamParams : params).then(res => {
                console.log('res（fn）',res);
                this.tableLoading = false
                if (res.length>0){
                this.list=res;
                }

                if (this.isTogglenumber) {
                    this.latestIssue = res.lastNumber
                }

                if (res.marketInfos.length>0) {
                    this.list = res.marketInfos.rows
                    this.listPagin.total = res.marketInfos.total
                }
            })
        },
        // 分页状态变化
        changePage (e) {
            this.tableLoading = true
            this.listPagin.page = e
            this.getList();
        },
        // 切换期号
        toggleNumber (tag, index) {
            this.isTogglenumber = false
            this.flagMark = index

            if (index == 0) {
                this.latestIssue = ''
                this.isTogglenumber = true
            } else {
                tag == 'prev' ? this.latestIssue-- : tag == 'next' ? this.latestIssue++ : ''
            }
            this.getList()
        },
        // 点击切换团队
        toggleTeam (ite) {
            console.log('item', ite);
            this.lotteryTeam.forEach(item => item.list.forEach(team => team.active = false));
            ite.active = true
            this.getList('team', ite.name)
        }
    }
}
</script>

<style lang="scss" scoped>
.selectMenu {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 0;
    > div {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        > span {
            text-align: right;
            width: 130px;
            padding: 15px 0;
        }
        > div {
            > span {
                display: inline-block;
                text-align: center;
                width: 100px;
                padding: 15px 0;
            }
        }
    }
}
.lottery {
    border: 1px solid rgba(0, 0, 0, 0.2);
    position: relative;
    span {
        background-color: #dbdbdb;
        padding: 20px 70px;
        display: inline-block;
        cursor: pointer;
        &.active {
            background-color: #93d2f3;
        }
    }
    .msg {
        color: #898af7;
        position: absolute;
        right: 10px;
        bottom: 0px;
    }
}
.sub {
    padding: 0 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
        padding: 20px 0px;
        &.btn {
            background-color: #347caf;
            color: #ffffff;
            padding: 5px 10px;
            border-radius: 5px;
        }
    }
    .team {
        flex: 1;
        margin-right: 20px;
        > div {
            display: flex;
            align-items: center;
            &:not(:last-child) {
                border-bottom: 1px solid;
            }
            > span {
                font-weight: bold;
            }
            span {
                padding: 15px 0px;
                margin: 0 20px;
            }
            > div {
                span {
                    cursor: pointer;
                }
            }
        }
    }
}
.tit {
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
        display: flex;
        align-items: center;
        margin: 0 20px;
        h3 {
            color: #347caf;
        }
        &.btn {
            background-color: #347caf;
            color: #ffffff;
            padding: 5px 10px;
            border-radius: 5px;
        }
        > div {
            margin-left: 20px;
            span {
                background-color: #dbdbdb;
                padding: 5px 10px;
                border-radius: 5px;
                margin-right: 20px;
                user-select: none;
                cursor: pointer;
                &.active {
                    background-color: #93d2f3;
                }
            }
        }
    }
}
.fenye {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .zhanwei {
        width: 25%;
    }
}
</style>